const initialState = {
  gender: [
    { id: "M", name: "Male" },
    { id: "F", name: "Female" },
    { id: null, name: "Do Not Disclose" },
  ],
  cities: [],
  states: [],
  countries: [],
  zipcodes: [],
};
/**
 * teporary save the state of passwords if user change his password
 * @param {object} state
 * @param {object} action
 */
const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CITY_LIST":
      return { ...state, cities: action.payload.cities };

    case "SET_STATE_LIST":
      return { ...state, states: action.payload.states };

    case "SET_COUNTRY_LIST":
      return { ...state, countries: action.payload.countries };

    case "ADD_ZIPCODE_DETAILS":
      return { ...state, zipcodes: action.payload.zipcodes };

    default:
      return state;
  }
};

export default profileReducer;
